import React from 'react';
import SeoMetadata from '../components/Seo/SeoMetadata';
import TituloPisoVinilicoLvt from '../components/sections/Piso-Vinilico-Lvt/TituloPisoVinilico-Lvt';
import IntroPisoVinilicoLVT from '../components/sections/Piso-Vinilico-Lvt/IntroPisoVinilico-Lvt';
import CatalogoPisoVinilicoLVT from '../components/sections/Piso-Vinilico-Lvt/CatalogoPisoVinilico-Lvt';
import BarraInfoNosotros from '../components/sections/BarraInfoNosotros';
import FormularioContactoLvt from '../components/sections/Piso-Vinilico-Lvt/FormularioContactoLvt';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';

const PisoVinilicoLvtPage = () => {
  return (
    <div>
      <SeoMetadata
        title="Piso Vinílico LVT | Decototal"
        description="Conoce los pisos vinílicos LVT y sus diseños para interiores. Explora características, modelos y opciones para renovar tus espacios."
        keywords="piso vinílico LVT, pisos LVT, piso vinílico para interiores, revestimiento de piso"
        path="/piso-vinilico-lvt-page"
        image="/assets/img/home/piso-vinilico-lvt.jpg"
      />
      <Header />
       {/* Titulo */}
       <TituloPisoVinilicoLvt />

      <IntroPisoVinilicoLVT />
      
      <CatalogoPisoVinilicoLVT />
      
      <BarraInfoNosotros />

      <FormularioContactoLvt />
      
      <Footer />
    </div>
  );
};

export default PisoVinilicoLvtPage;
